import { useRef, useState } from 'react';
import './profile.css';

function ChevronLeftIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M15 5l-7 7 7 7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function CameraPlusIcon() {
  return (
    <svg width="34" height="34" viewBox="0 0 24 24" fill="none">
      <path
        d="M9 5.5l-1.2 2H5a2 2 0 0 0-2 2V17a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7.5a2 2 0 0 0-2-2h-2.8L15 5.5H9Z"
        stroke="#7457e8"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="13" r="3.2" stroke="#7457e8" strokeWidth="1.8" />
    </svg>
  );
}

function SmileyIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9" stroke="#7457e8" strokeWidth="1.8" />
      <circle cx="9" cy="10.5" r="1.1" fill="#7457e8" />
      <circle cx="15" cy="10.5" r="1.1" fill="#7457e8" />
      <path d="M8.3 14.2c1 1.4 6.4 1.4 7.4 0" stroke="#7457e8" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

function PaletteIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 3a9 9 0 1 0 0 18c1.1 0 2-.9 2-2 0-.5-.2-1-.5-1.3-.3-.3-.5-.8-.5-1.3 0-1 .9-1.9 2-1.9H17a4 4 0 0 0 4-4c0-4.4-4-7.5-9-7.5Z"
        stroke="#7457e8"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <circle cx="7.5" cy="11" r="1.2" fill="#7457e8" />
      <circle cx="10.5" cy="7" r="1.2" fill="#7457e8" />
      <circle cx="15" cy="7.5" r="1.2" fill="#7457e8" />
    </svg>
  );
}

function ChevronRightIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path d="M9 5l7 7-7 7" stroke="#b7aee0" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function ShieldCheckIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 3l7 3v5c0 5-3.4 8.4-7 10-3.6-1.6-7-5-7-10V6l7-3Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function ArrowRightIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function ProfileIllustration() {
  return (
    <svg width="150" height="150" viewBox="0 0 150 150" fill="none">
      <circle cx="35" cy="30" r="4" fill="#ffffff" opacity="0.8" />
      <circle cx="122" cy="98" r="3" fill="#ffffff" opacity="0.7" />
      <path d="M108 34l3 8 8 3-8 3-3 8-3-8-8-3 8-3Z" fill="#ffffff" opacity="0.9" />
      <path d="M22 88l2.4 6 6 2.4-6 2.4-2.4 6-2.4-6-6-2.4 6-2.4Z" fill="#ffffff" opacity="0.75" />
      <rect x="35" y="20" width="80" height="95" rx="16" fill="#ffffff" />
      <rect x="43" y="28" width="64" height="79" rx="10" fill="#8a6df1" />
      <circle cx="75" cy="58" r="15" fill="#ffffff" />
      <path d="M52 100c0-13 10-21 23-21s23 8 23 21Z" fill="#ffffff" />
      <circle cx="112" cy="100" r="24" fill="#7457e8" />
      <path
        d="M104 92l-2 4h-4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h28a3 3 0 0 0 3-3V99a3 3 0 0 0-3-3h-4l-2-4h-16Z"
        fill="#ffffff"
      />
      <circle cx="112" cy="103" r="5" fill="#7457e8" />
    </svg>
  );
}

export default function ProfileStep({ onBack, onContinue, onSkip }) {
  const [photoUrl, setPhotoUrl] = useState(null);
  const fileInputRef = useRef(null);

  function handleFileChange(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    setPhotoUrl(URL.createObjectURL(file));
  }

  return (
    <div className="profile-screen">
      <div className="profile-frame">
        <div className="profile-header">
          <button type="button" className="profile-back-btn" onClick={onBack} aria-label="Go back">
            <ChevronLeftIcon />
          </button>
          <button type="button" className="profile-skip-btn" onClick={onSkip}>
            Skip
          </button>

          <div className="profile-glow" />
          <div className="profile-illustration-wrap">
            <ProfileIllustration />
          </div>
          <h1 className="profile-title">Add your profile picture</h1>
          <p className="profile-subtitle">Help people recognize you 😊</p>
        </div>

        <form
          className="profile-card"
          onSubmit={(e) => {
            e.preventDefault();
            onContinue?.({ photoUrl });
          }}
        >
          <input
            ref={fileInputRef}
            type="file"
            accept="image/jpeg,image/png"
            className="profile-file-input"
            onChange={handleFileChange}
          />

          <button
            type="button"
            className={`profile-upload-circle ${photoUrl ? 'has-photo' : ''}`}
            onClick={() => fileInputRef.current?.click()}
          >
            {photoUrl ? <img src={photoUrl} alt="Profile preview" /> : <CameraPlusIcon />}
          </button>

          <p className="profile-upload-text">
            {photoUrl ? 'Tap to change photo' : 'Tap to upload a photo'}
          </p>
          <p className="profile-upload-hint">JPG, PNG up to 5MB</p>

          <div className="profile-divider">
            <span />
            <p>or</p>
            <span />
          </div>

          <div className="profile-options">
            <button type="button" className="profile-option">
              <SmileyIcon />
              Choose an avatar
              <ChevronRightIcon />
            </button>
            <button type="button" className="profile-option">
              <PaletteIcon />
              Pick a color
              <ChevronRightIcon />
            </button>
          </div>

          <div className="profile-privacy">
            <div className="profile-privacy-icon">
              <ShieldCheckIcon />
            </div>
            <div>
              <p className="profile-privacy-title">Your photo is private</p>
              <p className="profile-privacy-text">
                Your profile picture is only visible to other users on the app.
              </p>
            </div>
          </div>

          <button type="submit" className="profile-submit">
            Continue <ArrowRightIcon />
          </button>
        </form>
      </div>
    </div>
  );
}
